import React, { useState, useEffect } from "react";
import { Table, Tag, Input, Button } from "antd";
import adminService from "../../../../services/adminService";
import ManageUserModal from "./ManageUserModal";

const AdminUserList = () => {
  const [users, setUsers] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  useEffect(() => {
    const getUserList = async () => {
      try {
        const res = await adminService.getCustomerData();
        if (res) {
          const formattedUsers = res.map((user, index) => ({
            id: user._id || index,
            name: user.name || "Unbekannt",
            email: user.email || "Keine E-Mail",
            role: user.roles.includes("admin")
              ? "admin"
              : user.subscription?.planName || "Basic User",
            registered: user.createdAt,
            status: user.subscription?.status || "unknown",

            // 👇 Hier erweitern wir um das komplette Abo-Objekt
            subscription: {
              plan: user.subscription?.plan || "-",
              planName: user.subscription?.planName || "-",
              contractDuration: user.subscription?.contractDuration || 0,
              startDate: user.subscription?.startDate || null,
              currentPeriodEnd: user.subscription?.currentPeriodEnd || null,
              endDate: user.subscription?.endDate || null,
              nextBillingDate: user.subscription?.nextBillingDate || null,
              pendingCancellation:
                user.subscription?.pendingCancellation || false,
              status: user.subscription?.status || "unbekannt",
            },
          }));
          setUsers(formattedUsers);
        }
      } catch (error) {
        console.error("Fehler beim Abrufen der Nutzerdaten:", error);
      }
    };
    getUserList();
  }, []);

  const getRoleTag = (role) => {
    const roleColors = {
      admin: "red",
      basic: "blue",
      standard: "green",
      pro: "purple",
    };
    return <Tag color={roleColors[role] || "default"}>{role}</Tag>;
  };

  const handleManageUser = (user) => {
    setSelectedUser(user);
    setIsModalOpen(true);
  };

  const handleModalCancel = () => {
    setIsModalOpen(false);
    setSelectedUser(null);
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => (
        <div className="p-2">
          <Input
            placeholder="Suche Name"
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() => confirm()}
            className="mb-2"
          />
        </div>
      ),
      onFilter: (value, record) =>
        record.name.toLowerCase().includes(value.toLowerCase()),
    },
    {
      title: "E-Mail",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Rolle",
      dataIndex: "role",
      key: "role",
      filters: [
        { text: "Admin", value: "Admin" },
        { text: "Basic User", value: "Basic User" },
        { text: "Standard User", value: "Standard User" },
        { text: "Pro User", value: "Pro User" },
      ],
      onFilter: (value, record) => record.role === value,
      render: (role) => getRoleTag(role),
    },
    {
      title: "Aktion",
      key: "action",
      render: (_, record) => (
        <div className="space-x-2">
          <Button
            type="primary"
            className="bg-orange-500 hover:!bg-orange-600"
            onClick={() => handleManageUser(record)}
          >
            Nutzer verwalten
          </Button>
        </div>
      ),
    },
  ];

  return (
    <div className="p-4 bg-white shadow rounded-lg">
      <h2 className="text-xl font-bold mb-4">Benutzerverwaltung</h2>
      <Table
        columns={columns}
        dataSource={users}
        rowKey="id"
        className="overflow-x-scroll"
      />
      <ManageUserModal
        isModalOpen={isModalOpen}
        handleModalCancel={handleModalCancel}
        userData={selectedUser}
      />
    </div>
  );
};

export default AdminUserList;
